import React from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../../../../ui-components/Spinner'
import StripePaymentMethodsList from './StripePaymentMethodsList';
import AddStripeCreditCardModal from './modals/AddStripeCreditCardModal';
import AlertModal from "../../../../../ui-components/AlertModal";
import CreditCardsAPI from '../../../../../apis/CreditCardsAPI';
import {intercomTrackEvent} from "../../../../../utils/Intercom/intercomHelper";
import without from "underscore/modules/without";
import findWhere from "underscore/modules/findWhere";
import { CHANGE_PAYMENT_METHOD } from '../../../../../stores/CartStateStore';

// used in AddStripeCreditCardModal
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_API_KEY);

function arrayWithout(array, id) {
    return without(array, findWhere(array, {
        id: id
    }));
}


export default class StripeCheckout extends React.Component {

    static contextTypes = {
        userAuthToken: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            methods: [],
            loading: false,
            loaded: false,
            showNewCreditCardModal: false,
            selectedMethod: null,
            errorModalText: null
        };

        CreditCardsAPI.SetUserAuthToken(props.userAuthToken);
    }

    componentWillReceiveProps(props) {
        if (!this.state.loaded && props.shown && this.props.venueAcceptsStripe) {
            // Transition from shown: false to shown: true
            // Reload the payment methods
            this.reloadPaymentMethods();

            intercomTrackEvent('credit-cards-tab-selected', {});
        } else {
            if (props.shown && !this.props.shown) {
                // Transition from shown: false to shown: true
                // updates cart payment method.
                // TODO: refactor this bad practice.
                if (!!this.state.selectedMethod) {
                    this.props.dispatchCartState({type: CHANGE_PAYMENT_METHOD, payload: {type: 'stripe', options: {method: this.state.selectedMethod}}})
                }
            }
        }
    }

    componentDidCatch(error, info) {
    }

    reloadPaymentMethods() {
        this.setState({loading: true});

        CreditCardsAPI.GetCreditCards().then((response) => {
            let cards = response.cards || [];
            let defaultMethod = response.default_source;

            //Check for American Express cards
            for (let card of cards) {
                if (card.brand === "American Express") {
                    this.deletePaymentMethod(card);
                    return;
                }
            }

            this.setState({methods: cards, loaded: true, loading: false, selectedMethod: defaultMethod});

            if (defaultMethod) {
                // Set as current method the first card
                this.props.dispatchCartState({type: CHANGE_PAYMENT_METHOD, payload: {type: 'stripe', options: {method: defaultMethod}}})
            } else {
                this.props.dispatchCartState({type: CHANGE_PAYMENT_METHOD, payload: {type: 'stripe', options: {}}})
            }
        }).catch((err) => {
            const res = err.response;

            const error_message = (res && res.body && res.body.error) ? (I18n.t("cart_summary.credit_cards.errors.cannot_get_cards") + ": " + res.body.error) : I18n.t("cart_summary.credit_cards.errors.cannot_get_cards");
            this.setState({ errorModalText: error_message, methods: [], selectedMethod: null, loaded: true, loading: false});
        });
    }

    createPaymentMethod(method) {
        CreditCardsAPI.CreateCreditCard(method); // async, don't wait the result
        this.setState({loading: false, methods: this.state.methods.concat(method)});

        this.changeSelectedPaymentMethod(method);

        //const res = err.response;
        //const error_message = (res && res.body && res.body.error) ? (I18n.t("cart_summary.credit_cards.errors.cannot_add") + ": " + res.body.error) : I18n.t("cart_summary.credit_cards.errors.cannot_add");
        //this.setState({errorModalText: error_message, loading: false});
    }

    changeSelectedPaymentMethod = (paymentMethod) => {
      this.setState({selectedMethod: paymentMethod.id});
      this.props.dispatchCartState({type: CHANGE_PAYMENT_METHOD, payload: {type: 'stripe', options: {method: paymentMethod.id}}})
    };

    deletePaymentMethod = (method) => {
        CreditCardsAPI.DeleteCreditCard(method);

        this.setState({methods: arrayWithout(this.state.methods, method.id)});

        /*CreditCardsAPI.DeleteCreditCard(method).then((response) => {
            this.setState({loading: false});
            this.reloadPaymentMethods();
        }).catch((err) => {
            const res = err.response;

            const error_message = (res && res.body && res.body.error) ? (I18n.t("cart_summary.credit_cards.errors.cannot_remove") + ": " + res.body.error) : I18n.t("cart_summary.credit_cards.errors.cannot_remove");
            this.setState({errorModalText: error_message, loading: false});
            this.reloadPaymentMethods();
        });*/
    };

    showNewCardForm = (event) => {
        event.preventDefault();

        this.setState({showNewCreditCardModal: true});
    };

    hideNewCardForm = () => {
        this.setState({showNewCreditCardModal: false});
    };

    handleNewCreditCard = (method) => {
        this.hideNewCardForm();
        this.createPaymentMethod(method);
    };

    renderPaymentMethods(showAlertMessage) {
        return (this.state.methods.length > 0) ?
            <div style={{marginTop: 20}} className="clearfix">
                <p className="checkout-info">{I18n.t("cart_summary.credit_cards.pre_auth_instructions")}</p>
                {showAlertMessage && <p className="checkout-info primary-2-style" >
                    <b>{I18n.t("cart_summary.credit_cards.delivery_price_instructions")}</b>
                </p>}
            </div> : null
    }

    renderSpinner() {
        return <Spinner/>;
    }

    renderNoStripe() {
        return (<div>{I18n.t("cart_summary.venue_no_credit_cards")}</div>);
    }

    renderStripeForm() {
        return (<div>
            <AlertModal title="Attenzione!"
                        text={this.state.errorModalText}
                        show={!!this.state.errorModalText}
                        onClose={() => this.setState({errorModalText: null})}/>

            <div className="row">
                <div className="col-sm-12">
                    {(this.state.methods.length === 0) ?
                        <p>{I18n.t("cart_summary.credit_cards.no_credit_cards_present")}</p> :
                        <StripePaymentMethodsList
                            methods={this.state.methods}
                            selectedMethod={this.state.selectedMethod}
                            onPaymentMethodSelected={this.changeSelectedPaymentMethod}
                            onPaymentMethodDeleted={this.deletePaymentMethod}/>
                    }

                    <div className="item">
                        <a className="btn btn-blue pull-right separated" href="#"
                           onClick={this.showNewCardForm}>{I18n.t("cart_summary.credit_cards.add_cart")}</a>
                        <div className="clearfix"/>
                    </div>

                    {this.renderPaymentMethods(this.props.showAlertMessage)}
                </div>
            </div>
            <AddStripeCreditCardModal
                stripe_key={this.props.stripe_key}
                onNewCreditCard={this.handleNewCreditCard}
                onNewCreditCardError={(message) => this.setState({errorModalText: message}) }
                onHide={this.hideNewCardForm}
                show={this.state.showNewCreditCardModal}/>
        </div>)
    }

    render() {
        if (this.state.loading) {
            return this.renderSpinner();
        } else {
            if (this.props.venueAcceptsStripe) {
                return this.renderStripeForm();
            } else {
                return this.renderNoStripe()
            }
        }
    }
}
